import { render, staticRenderFns } from "./add-care-admin-royalty-free-popup.vue?vue&type=template&id=a5dae20e"
import script from "./add-care-admin-royalty-free-popup.vue?vue&type=script&lang=js"
export * from "./add-care-admin-royalty-free-popup.vue?vue&type=script&lang=js"
import style0 from "./add-care-admin-royalty-free-popup.vue?vue&type=style&index=0&id=a5dae20e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports